<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="absolute top-right">
      <button type="button" class="btn-primary">Add New</button>
    </div>
    <div class="h-full">
      <ul class="space-y-3">
        <li
          v-for="(item, index) in items"
          :key="item._id"
          class="bg-white overflow-hidden px-6 py-4"
        >
          <div class="flex flex-row justify-start">
            <div class="flex-none px-4 align-top w-16">
              <label class="font-bold">
                {{ index + 1 }}
              </label>
            </div>
            <div class="flex-grow px-4 align-top">
              <div class="grid grid-cols-2">
                <div>
                  <label class="font-bold capitalize text-xl">
                    {{ item.name }}
                  </label>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn-gray"
                    @click="copyInviteLink(item._id, index)"
                  >
                    {{
                      item.isCopied ? 'Link Copied ✔' : 'Copy Invite Link 📋'
                    }}
                  </button>
                </div>
              </div>
              <div class="pt-2">
                <label class="font-bold"> Sub Topics </label>
              </div>
              <div class="">
                <label class="font-thin capitalize">
                  {{
                    item.subTopics.length > 0 ? item.subTopics.join(', ') : '-'
                  }}
                </label>
              </div>
              <div class="pt-2">
                <label class="font-bold"> Keywords </label>
              </div>
              <div class="">
                <label class="font-thin capitalize">
                  {{
                    item.keywords.length > 0 ? item.keywords.join(', ') : '-'
                  }}
                </label>
              </div>
            </div>
            <div class="flex flex-none flex-row justify-end">
              <div class="px-1">
                <font-awesome-icon
                  class="reaction text-gray-700 hover:text-blue-500 cursor-pointer"
                  size="lg"
                  :icon="['far', 'edit']"
                />
              </div>
              <div class="px-1">
                <font-awesome-icon
                  class="reaction text-gray-700 hover:text-red-500 cursor-pointer"
                  size="lg"
                  :icon="['far', 'trash-alt']"
                />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import adminAPI from '@/services/admin';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'topics',
  layout: 'admin',
  store,
  data() {
    return {
      items: [],
      isCopied: false,
    };
  },
  async mounted() {
    store.commit('toggleLoading', true);
    adminAPI
      .getTopics()
      .then((data) => {
        store.commit('toggleLoading', false);

        this.items = data.map((v) => ({ ...v, isCopied: false }));
      })
      .catch((error) => {
        store.commit('toggleLoading', false);
        if (error.response.status === 401) {
          utils.setStatusMsg(
            this,
            'Unauthorized access, redirected to implicit',
          );
          this.$router.push({ path: '/' });
        }
        console.log({ error });
      });
  },
  methods: {
    copyInviteLink(topicId, index) {
      const link = `https://sites.recap.ai/m/member?t=${topicId}`;
      navigator.clipboard.writeText(link).then(
        () => {
          this.items[index].isCopied = true;
          // eslint-disable-next-line
          setTimeout(() => {
            this.items[index].isCopied = false;
          }, 3000);
          console.log('Async: Copying to clipboard was successful!');
        },
        (err) => {
          console.error('Async: Could not copy text: ', err);
        },
      );
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
